import React from 'react';
import { allowedTypeSource, CLOSE_NETSPACE_DRAWER } from "./NetSpaceConstant";
import { useSelector, useDispatch } from 'react-redux';
import Page_Loader from "../../assets/vizr_images/page_loader.gif";
import Drawer from "@material-ui/core/Drawer";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "../../assets/vizr_images/ic_remove.svg";
import { Button, useMediaQuery } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import {
    renderIsMonitored,
    renderAlerts,
    renderHostIPFnWrapper,
    renderHostType,
    renderOS,
    renderPorts,
    renderNames,
    renderTags,
    renderHostName,
    renderHostMacAddress,
    renderSource,
    renderCVEScore,
    renderCVESeverity,
    renderCVEId,
    renderUserTagsWithHostTag
} from './NetSpaceUtils';
const useStyles = makeStyles({
    paper: {
        background: "white",
    }
});
const NetSpaceDrawer = () => {
    const classes = useStyles();
    const isSmall = useMediaQuery("(max-width:1600px)");
    const dispatch = useDispatch();
    const renderHostIP = renderHostIPFnWrapper(dispatch);
    const drawerLoader = useSelector((state) => state.NetspaceReducer.drawerLoader);
    const selectedHost = useSelector((state) => {
        const params = {};
        params['row'] = state.NetspaceReducer.selectedHost
        return params;
    });
    const drawerIsOpen = useSelector((state) => state.NetspaceReducer.drawerIsOpen);
    const renderNetSpaceHostDetails = () => {
        return (
            drawerLoader ? (
                <img
                    src={Page_Loader}
                    alt="loading"
                    className="loader-data-source tenantProfileLoader"
                ></img>
            ) :
                (
                    <>
                        <div
                            className='netspace_drawer_main'
                        >
                            <div className="netspace_drawer_container">
                                <div
                                    className="netspace_drawer_header">
                                    <div className="netspace_details">Host Details</div>
                                    <Button
                                        className='close_drawer'
                                        onClick={(event) => dispatch({ type: CLOSE_NETSPACE_DRAWER })}
                                        aria-label="close"
                                    >
                                        <img src={CloseIcon} alt={"close"} />
                                    </Button>
                                </div>
                                <div className="netspace_part2">
                                    <>
                                        <div className="netspace_content_DB">
                                            <span className='header'>Host IP:</span>{" "}{renderHostIP(selectedHost)}
                                        </div>
                                        <Divider />
                                        <div className="netspace_content_DB">
                                            <span className='header'>Host Name:</span>{" "}{renderHostName(selectedHost)}
                                        </div>
                                        <Divider />
                                        <div className="netspace_content_DB">
                                            <span className='header'>Mac Address:</span>{" "}{renderHostMacAddress(selectedHost)}
                                        </div>
                                        <Divider />
                                        <div className="netspace_content_DB">
                                            <span className='header'>CVE IDs:</span>{" "}{renderCVEId(selectedHost, "fullView")}
                                        </div>
                                        <Divider />
                                        <div className="netspace_content_DB">
                                            <span className='header'>CVE Score:</span>{" "}{renderCVEScore(selectedHost)}
                                        </div>
                                        <Divider />
                                        <div className="netspace_content_DB">
                                            <span className='header'>CVE Severity:</span>{" "}{renderCVESeverity(selectedHost)}
                                        </div>
                                        <Divider />
                                        <div className="netspace_content_DB">
                                            <span className='header'>OS:</span>{" "}{renderOS(selectedHost, "fullView")}
                                        </div>
                                        <Divider />
                                        <div className="netspace_content_DB">
                                            <span className='header'>System Tags:</span>{" "}{renderTags(selectedHost, "fullView")}
                                        </div>
                                        <Divider />
                                        <div className="netspace_content_DB">
                                            <span className='header'>Security Alerts:</span>{" "}{renderAlerts({ value: selectedHost.row.alertSegregation })}
                                        </div>
                                        <Divider />
                                        <div className="netspace_content_DB">
                                            <span className='header'>Source Type:</span>{" "}{renderSource(selectedHost, "fullView")}
                                        </div>
                                        <Divider />
                                        <div className="netspace_content_DB">
                                            <span className='header'>Visibility:</span>{" "}{renderIsMonitored(selectedHost)}
                                        </div>
                                        <Divider />
                                        <div className="netspace_content_DB">
                                            <span className='header'>{allowedTypeSource.includes(selectedHost?.row?.sourceType) ? "Type:" : "Host Type:"}</span>{" "}{renderHostType(selectedHost, "fullView")}
                                        </div>
                                        <Divider />
                                        <div className="netspace_content_DB">
                                            <span className='header'>User Tags:</span>{" "}{renderUserTagsWithHostTag(selectedHost,null, dispatch, "fullView", )}
                                        </div>
                                        <Divider />
                                        <div className="netspace_content_DB">
                                            <span className='header'>Ports:</span>{" "}{renderPorts(selectedHost, "fullView", isSmall)}
                                        </div>
                                    </>
                                </div>
                            </div>
                        </div>
                    </>
                )
        );
    };
    return (
        drawerIsOpen ? (
            <React.Fragment>
                <Drawer
                    classes={{
                        paper: classes.paper,
                    }}
                    anchor={"right"}
                    open={drawerIsOpen}
                    onClose={(event) => dispatch({ type: CLOSE_NETSPACE_DRAWER })}
                >
                    {renderNetSpaceHostDetails()}
                </Drawer>
            </React.Fragment>
        ) : null
    );
};

export default NetSpaceDrawer;